export  default {
    getAddSiteResults(state) {
        return state.newSite;
    },
    getDecommissionSiteResults(state) {
        return state.decommissionSite;
    },
    getBulkImportResults(state) {
        return state.bulkImportResults;
    }
};